module.exports = __webpack_public_path__ + "img/antes_despues_63.eed666f9.png";